import FormattedDate from './FormattedDate';

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/views/components/Common/FormattedDate/index.js